<!-- 工控-站点反控 -->
<template>
  <div>
    <el-card style="position: relative; z-index: 0; width: 100%">
      <div slot="header" class="clearfix" v-if="!showChooseVisible">
        <el-button @click="$router.back()" class="pull-left">
          <i class="fa fa-chevron-left fa-fw"></i> 返回 </el-button
        >&nbsp;
        <el-tag size="medium" v-if="stationName">{{ stationName }}</el-tag>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="站点反控" name="first">
          <div style="padding-bottom: 10px">
            <el-button
              type="success"
              @click="onSelectDevice()"
              v-if="showChooseVisible"
            >
              <i class="fa fa-plus"></i> 选择站点
            </el-button>
            <el-button @click="showGetCommandTab1()">
              <i class="fas fa-upload"></i> 加载命令
            </el-button>
            <!-- <el-button @click="showNewCommandTab1()">
              <i class="fas fa-download"></i> 新增命令
            </el-button> -->
          </div>
          <el-form :model="itemTab1" ref="itemform" label-width="100px">
            <el-form-item label="命令主题">
              <el-col :span="18">
                <el-input
                  v-model="topics"
                  type="textarea"
                  :autosize="{ minRows: 1, maxRows: 10 }"
                  placeholder="命令主题"
                >
                </el-input>
                <span class="text-muted"
                  >您选择的站点为：{{ itemTab1.auth_code.join(",") }}</span
                >
              </el-col>
              <el-col :span="6">
                <span
                  class="text-muted pad-x-xs pull-left"
                  style="font-size: 14px; line-height: 140%"
                >
                  默认命令主题为
                  <span class="text-danger bg-muted text-xs"
                    >&nbsp;授权码/配置的命令主题&nbsp;</span
                  >
                  <br />可使用回车输入多个主题同时发送
                </span>
              </el-col>
            </el-form-item>
            <el-form-item label="命令内容" prop="Payload">
              <el-col :span="18">
                <el-input
                  v-model="itemTab1.Payload"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 10 }"
                  placeholder="命令内容"
                >
                </el-input>
              </el-col>
              <el-col :span="6">
                <span
                  class="text-muted pad-x-xs pull-left"
                  style="font-size: 14px; line-height: 140%"
                >
                  建议使用JSON格式的命令，系统下发JSON命令时会插入
                  <span class="text-danger bg-muted text-xs"
                    >&nbsp;$cdsn&nbsp;</span
                  >
                  作为命令的唯一编号。
                </span>
              </el-col>
            </el-form-item>
            <el-form-item label="命令质量" v-if="false">
              <el-radio-group v-model="itemTab1.Qos">
                <el-radio :label="0">QoS 0</el-radio>
                <el-radio :label="1">QoS 1</el-radio>
                <el-radio :label="2">QoS 2</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="text-center">
              <el-button type="primary" @click="onSendItemTab1()">
                <i class="fa fa-paper-plane"></i> 发 送
              </el-button>
              <!-- <el-button @click="onClearItemTab1()">
                  <i class="fa fa-plus"></i> 清 空
                </el-button> -->
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="命令管理" name="second" v-if="getPermission()">
          <!--group: 业务组类型 0.嵌入式 1.工控，必传0 -->
          <CommandDiv group="1"></CommandDiv>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 站点反控 -->
    <div v-if="activeName === 'first'">
      <el-card
        class="hover-color-change mar-t-md"
        style="position: relative; z-index: 0; width: 100%"
      >
        <div slot="header" class="clearfix">
          <span class="pull-left text-sm text-muted">
            <i class="fa fa-link"></i> 快捷命令
          </span>
        </div>
        <div>
          <el-button
            round
            plain
            v-for="item in itemListQuickCommand"
            :key="item.ID"
            @click="onSendQuickCommandClick(item)"
            type="success"
            size="small"
            :title="item.Desc"
            >{{ item.Name }}
          </el-button>
        </div>
      </el-card>

      <el-card
        class="hover-color-change mar-t-md"
        style="position: relative; z-index: 0; width: 100%"
      >
        <div slot="header" class="clearfix">
          <span class="pull-left text-sm text-muted">
            <i class="fa fa-fw fa-list-ol"></i> 站点反控记录&nbsp;
            <el-select
              v-model="commSelect"
              placeholder="请选择站点授权码"
              style="width: 300px"
              clearable
              @change="getItemListTab1"
            >
              <el-option
                v-for="sn in itemTab1.auth_code"
                :key="sn"
                :label="sn"
                :value="sn"
              ></el-option> </el-select
            >&nbsp;
            <el-button
              type="text"
              title="刷新反控记录"
              @click="getItemListTab1()"
            >
              <i class="fa fa-sync"></i
            ></el-button>
          </span>
        </div>
        <div>
          <el-table
            :data="itemListTab1"
            v-loading="loading"
            tooltip-effect="light"
          >
            <el-table-column label="发送命令主题/内容" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <div>
                  <el-tag>{{ row.Topic }}</el-tag>
                </div>
                <div>
                  {{ row.Payload }}
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="Payload"
              label="请求内容"
              show-overflow-tooltip
            ></el-table-column> -->
            <el-table-column label="请求人/时间" width="150">
              <template slot-scope="{ row }">
                <div>
                  {{ row.Person }}
                </div>
                <div>
                  <span v-if="row.CreatedAt">
                    {{ row.CreatedAt.replace("T", " ").substring(0, 19) }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="返回命令主题/内容" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <div v-if="row.BackTopic">
                  <el-tag type="success">{{ row.BackTopic }}</el-tag>
                </div>
                <div v-if="row.BackPayload">
                  {{ row.BackPayload }}
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="BackPayload"
              label="返回内容"
              show-overflow-tooltip
            ></el-table-column> -->
            <el-table-column prop="BackAt" label="返回时间" width="160">
              <template slot-scope="{ row }">
                <span v-if="row.BackAt">
                  {{ row.BackAt.replace("T", " ").substring(0, 19) }}</span
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="paginator">
            <el-pagination
              @current-change="onChangePageTab1"
              layout="total, prev, pager, next"
              :total="pagerTab1.total"
              :current-page="pagerTab1.page"
              :page-size="pagerTab1.size"
            >
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>

    <ItemDevice :visible.sync="deviceVisible" @update="getDeviceSnTab1">
    </ItemDevice>

    <ItemCommand
      :commandVisibleProp.sync="commandVisible"
      @update="getCommandTab1"
    >
    </ItemCommand>

    <QuickCommand
      :command="quickItem"
      :quickSendInfo="quickSendInfo"
      :visible.sync="quickCommandVisible"
      @connectData="connectHandle"
      @form:saved="getItemListTab1"
    ></QuickCommand>
  </div>
</template>

<script>
import ItemDevice from "./index--device.vue";
import ItemCommand from "./index--command.vue";
import CommandDiv from "../../basic/commandManage/index.vue";
import QuickCommand from "../../basic/commandManage/quickcommand.vue";

export default {
  components: {
    ItemDevice,
    ItemCommand,
    CommandDiv,
    QuickCommand,
  },
  data() {
    return {
      connectData: null,
      termVisible: false,
      editorVisible: false,
      selectedRow: null,
      activeName: "first",
      topics: "", // 主题
      itemListTab1: [],
      itemTab1: {
        Topics: [],
        Title: "",
        station_id: [],
        auth_code: [],
        Payload: "",
        Qos: 2,
      },
      commSelect: "",
      pagerTab1: {
        total: 0,
        page: 1,
        size: 15,
      },
      deviceVisible: false,
      commandVisible: false,
      // newCommandVisible: false,
      loading: false,
      itemListQuickCommand: [], //快捷命令列表
      quickItem: {}, //点击的快捷命令
      quickSendInfo: {}, //快捷命令信息
      quickCommandVisible: false,
      showChooseVisible: true, //是否显示选择产品按钮
      stationName: "",
    };
  },
  mounted() {
    if (this.$route.query.code) {
      // this.topics = `${this.$route.query.code}`;
      this.showChooseVisible = false;
      this.stationName = this.$route.query.name;
      this.itemTab1.auth_code = [`${this.$route.query.code}`];
      this.itemTab1.station_id = [this.$route.query.id - 0];
      this.bindTitle();
      this.getItemListTab1();
    }
    this.getQuickCommand();
  },
  methods: {
    connectHandle(data) {
      this.connectData = data;
      this.termVisible = true;
    },
    //获取快捷命令管理列表
    getQuickCommand() {
      this.$axios
        .get("command/list", {
          params: {
            where: {
              BusinessGroup: 1, //业务组类型 0.嵌入式 1.工控，必传1
              IsPublic: 1, //是否公开0:否  1:是
            },
            total: 0,
            page: 1,
            size: 100,
            order: ["name"],
          },
        })
        .then((response) => {
          this.itemListQuickCommand = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 获取站点反控列表
    getItemListTab1() {
      if (!this.itemTab1.station_id.length) {
        this.$message.warning("请至少选择一个站点!");
        return;
      }
      let ids = [];
      if (this.commSelect !== "") {
        let index = this.itemTab1.auth_code.indexOf(this.commSelect);
        ids.push(this.itemTab1.station_id[index]);
      } else {
        ids = this.itemTab1.station_id;
      }
      this.loading = true;
      this.$axios
        .get("ipc/communication", {
          params: {
            ids: ids,
            ...this.pagerTab1,
            order: ["-created_at", "-id"],
          },
        })
        .then((response) => {
          this.itemListTab1 = response.data.data;
          this.pagerTab1 = _.pick(response.data, "size", "page", "total");
          if (this.pagerTab1.page > response.data.last) {
            this.pagerTab1.page = response.data.last;
            this.getItemListTab1();
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 站点反控-获取选中站点
    getDeviceSnTab1(options) {
      this.commSelect = "";
      this.itemTab1.auth_code = options.map((e) => e.Code.Name);
      this.itemTab1.station_id = options.map((e) => e.ID);

      this.bindTitle();
      this.getItemListTab1();
    },

    // 站点反控-获取调用命令
    getCommandTab1(command) {
      this.itemTab1.Payload = command.Payload;
      this.itemTab1.Title = command.Title;
      this.bindTitle();
    },
    bindTitle() {
      this.itemTab1.Topics = [];
      this.itemTab1.auth_code.forEach((code) => {
        if (this.itemTab1.Title !== "") {
          this.itemTab1.Topics.push(`${code}/${this.itemTab1.Title}`);
        } else {
          this.itemTab1.Topics.push(`${code}`);
        }
      });
      this.topics = this.itemTab1.Topics.join("\n");
    },
    onSelectDevice() {
      this.deviceVisible = true;
    },
    showGetCommandTab1() {
      this.commandVisible = true;
    },

    // tab1翻页
    onChangePageTab1(page) {
      this.pagerTab1.page = page;
      this.getItemListTab1();
    },
    // 站点反控-发送命令
    onSendItemTab1() {
      if (!this.itemTab1.station_id.length) {
        this.$message.warning("请至少选择一个站点!");
        return;
      }
      this.itemTab1.Topics = this.topics.split("\n");
      var btop = false;
      this.itemTab1.Topics.forEach((topic) => {
        if (topic.indexOf("$") !== -1) {
          btop = true;
        }
      });
      if (!btop) {
        this.$message.warning("请确认发送主题是否正确!");
        return;
      }
      // if (!this.itemTab1.Payload) {
      //   this.$message.warning("命令内容必填!");
      //   return;
      // }

      const data = {
        DciDeviceIDs: this.itemTab1.station_id,
        Topics: this.itemTab1.Topics,
        Payload: this.itemTab1.Payload, // JSON.parse(this.item.Payload),
        Qos: this.itemTab1.Qos,
      };
      this.$axios
        .post("ipc/communication/customcontrol", data)
        .then(() => {
          this.$message.success("发送成功");
          this.getItemListTab1();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    //站点反控-点击快捷命令按钮
    onSendQuickCommandClick(item) {
      if (!this.itemTab1.station_id.length) {
        this.$message.warning("请选择站点!");
        return;
      }
      this.itemTab1.Title = item.Title;
      this.bindTitle();
      const data = {
        DciDeviceIDs: this.itemTab1.station_id,
        Topics: this.itemTab1.Topics,
        Payload: item.Payload, // JSON.parse(this.item.Payload),
        Qos: 2,
      };

      //有额外参数
      if (item.ExtraParams.length > 0) {
        this.quickItem = item;
        this.quickSendInfo = data;
        this.quickCommandVisible = true;
      } else {
        //无额外参数，直接发送快捷命令
        this.$axios
          .post("ipc/communication/customcontrol", data)
          .then(() => {
            this.$message.success("发送成功");
            this.getItemListTab1();
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      }
    },

    getPermission() {
      var has = false;
      if (this.$store.state.Auth.user.Permissions) {
        this.$store.state.Auth.user.Permissions.forEach((perm) => {
          if ("command-*" === perm.Obj + "-" + perm.Act) {
            has = true;
          }
        });
      }
      return has;
    },
  },
};
</script>

<style scoped lang="scss" scoped>
.top {
  text-align: right;
  background-color: #f5f7fa;
  height: 30px;
  padding: 35px 30px 10px 30px;
  margin: -20px -20px 10px -20px;
}
.left {
  float: left;
  text-align: left;
  width: 20%;
}
.right {
  float: right;
  text-align: right;
  width: 80%;
}
#app {
  width: 100%;
  height: 100%;
  .el-table {
    // 看这里！！！！！！！！！！！！！！！！！！！！！！！！！！！！
    // 深度选择器，去除默认的padding
    /deep/ th {
      padding: 0 0 10 0;
      font-size: larger;
    }
  }
}
.noLabel .el-checkbox__label {
  display: none;
}
.hover-color-change .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #9df;
}
.hover-color-change .el-table__body tr.current-row > td {
  background-color: #9df;
}
</style>
